const OUTPUT_SCALE = 2;
const PDF_TO_CSS_UNITS = 96 / 72;
export { PDF_TO_CSS_UNITS as n, OUTPUT_SCALE as t };
